export default "/images/logo-bissell.svg?6f9fdfb0a93bbeada2970ab40a9177b4";